import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA004_Request,
  IAPI_STA004_Response,
} from "../../../type/apiType";

// 育休情報　登録表示
const httpAPI_STA004 = async (
  param: IAPI_STA004_Request
): Promise<IAPI_STA004_Response> => {
  let res = await http.post(ApiUrl.API_STA004, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA004 };
